module.exports = __webpack_public_path__ + "img/BondLogix_Horiz.2d779a23.png";